import { Component } from "@angular/core";
import { BaseComponent } from "../../shared";

@Component({
  selector: 'account-sub-route',
  templateUrl: './accountSubRouteComponent.html'
})
export class AccountSubRouteComponent extends BaseComponent {

}